import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { City } from './city';
import { environment } from '../environments/environment';
 

const httpOptions = {
  headers: new HttpHeaders({ 'Content-Type': 'application/json' })
};
 
@Injectable({
  providedIn: 'root'
})
export class CityService {
	baseUrl = environment.baseUrl;
  private citiesUrl = this.baseUrl + '/api/cities';  // URL to web api
  private citiesBystateidUrl = this.baseUrl +  '/api/cities/getstates';  // URL to web api
  constructor( 
    private http: HttpClient
  ) { }
 
  getCities (): Observable<City[]> {
    return this.http.get<City[]>(this.citiesUrl)
  }
 
  getCity(cityid: number): Observable<City> {
    const url = `${this.citiesUrl}/${cityid}`;
    return this.http.get<City>(url);
  }
  
  getCityByState(stateid: number): Observable<City[]> {
    const url = `${this.citiesBystateidUrl}/${stateid}`;
    return this.http.get<City[]>(url);
  }
 
  addCity (city: City): Observable<City> {
    return this.http.post<City>(this.citiesUrl, city, httpOptions);
  }
 
  deleteCity (city: City | number): Observable<City> {
    const id = typeof city === 'number' ? city : city.cityid;
    const url = `${this.citiesUrl}/${id}`;
 
    return this.http.delete<City>(url, httpOptions);
  }
 
  updateCity (city: City): Observable<any> {
    return this.http.put(this.citiesUrl, city, httpOptions);
  }
}